import { createContext } from 'react';

export const NotificationTemplateContext = createContext<any>(undefined as any);
